import { render, staticRenderFns } from "./qfcm.vue?vue&type=template&id=3ecda872&scoped=true"
import script from "./qfcm.vue?vue&type=script&lang=js"
export * from "./qfcm.vue?vue&type=script&lang=js"
import style0 from "./qfcm.vue?vue&type=style&index=0&id=3ecda872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecda872",
  null
  
)

export default component.exports